export const AuthConstants = Object.freeze({
  AUTH_TYPE_NOOS: 'noos',
  AUTH_TYPE_SSO: 'sso',
  SSO_MICROSOFT: 'microsoft',
  SSO_GOOGLE: 'google',
  GOOGLE_SSO_CLOSED_POPUP_ERROR: 'popup_closed_by_user',
  AUTH_ERROR_UNKNOWN: 'Unknown error'
});
